import axios from "axios";
import { API_URL } from "../constants/api";

// Separate Axios instance for admin/onboarding portal — uses admin_token
const adminApiClient = axios.create({
  baseURL: API_URL,
  timeout: 60000, // longer timeout for DB provisioning
  headers: { "Content-Type": "application/json" },
});

adminApiClient.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem("admin_token");
    if (token) {
      config.headers.Authorization = `Token ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

adminApiClient.interceptors.response.use(
  (response) => response.data,
  (error) => {
    if (error.response?.status === 401) {
      sessionStorage.removeItem("admin_token");
      sessionStorage.removeItem("admin_name");
      window.location.href = "/admin/login";
    }
    return Promise.reject(error);
  }
);

export default adminApiClient;
